module.exports = __webpack_public_path__ + "img/03.75814996.jpg";